import { render } from "./OrderDialog.vue?vue&type=template&id=86c44ec2&scoped=true"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"

import "./OrderDialog.vue?vue&type=style&index=0&id=86c44ec2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c44ec2"]])

export default __exports__